module.exports = __webpack_public_path__ + "img/joyNoBook.94ece0e3.png";